import axios from 'axios';
import { toast } from 'sonner';
import i18n from '../i18n';

const baseURL = process.env.REACT_APP_BASEURL|| 'http://localhost:3001';

const isPt = () => (i18n.language || 'pt').startsWith('pt');

// Throttle para evitar dezenas de toasts iguais quando várias requests estouram em sequência
let lastRateLimitToastAt = 0;
const RATE_LIMIT_TOAST_COOLDOWN_MS = 5000;

const api = axios.create({
  baseURL: baseURL
});

// ========================================
// INTERCEPTOR: Adiciona token JWT automaticamente
// ========================================
api.interceptors.request.use(
  (config) => {
    // Pega o token do localStorage
    const token = localStorage.getItem('token');

    // Se o token existir, adiciona no header Authorization
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ========================================
// INTERCEPTOR: Trata erros de autenticação
// ========================================
api.interceptors.response.use(
  (response) => {
    // Se a resposta for bem-sucedida, apenas retorna
    return response;
  },
  (error) => {
    // 429: rate limit do backend. Mostra toast claro em vez do "Algo deu errado" genérico.
    if (error.response && error.response.status === 429) {
      const now = Date.now();
      if (now - lastRateLimitToastAt > RATE_LIMIT_TOAST_COOLDOWN_MS) {
        lastRateLimitToastAt = now;
        toast.error(isPt()
          ? 'Você fez muitas requisições. Aguarde alguns minutos e tente novamente.'
          : 'You made too many requests. Wait a few minutes and try again.');
      }
    }

    // Se receber 401 (não autenticado), limpa o token e redireciona para login
    // Mas não interfere em requisições de login/registro
    if (error.response && error.response.status === 401) {
      const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                            error.config?.url?.includes('/auth/register');
      
      // Não interfere em erros de login/registro - deixa o componente tratar
      if (!isAuthEndpoint) {
        localStorage.removeItem('token');
        localStorage.removeItem('SistemaUser');

        // Redireciona para login se não estiver em uma rota pública
        const publicPaths = ['/', '/signin', '/login'];

        if (!publicPaths.includes(window.location.pathname)) {
          window.location.href = '/signin';
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
